import {createAsyncThunk} from '@reduxjs/toolkit'
import {
  FetchTypeExamByIdRequest,
  UpdateTypeExamRequest,
  FetchTypeExamsRequest,
  CreateTypeExamRequest,
  DeleteTypeExamRequest,
  SuspendTypeExamRequest,
  ActivateTypeExamRequest,
  FetchAllTypeExamsRequest
} from './types'
import {AxiosError} from 'axios'
import {ResponseError} from '../commonTypes'
import {TypeExam} from '../../../models'
import axios from 'axios'
import {
  fetchTypeExamsUrl,
  fetchTypeExamByIdUrl,
  createTypeExamUrl,
  updateTypeExamUrl,
  deleteTypeExamUrl,
  suspendTypeExamUrl,
  activateTypeExamUrl,
  fetchAllTypeExamsUrl
} from '../../api'

export const fetchTypeExams = createAsyncThunk(
  'typeExam/fetch',
  async (payload: FetchTypeExamsRequest, {rejectWithValue}) => {
    try {
      const res = await axios.get(
        `${fetchTypeExamsUrl}?sortField=${payload.sortField}&sortOrder=${
          payload.sortOrder
        }&pageNumber=${payload.pageNumber}&pageCount=${payload.pageCount}${
          payload.search && payload.search.trim() !== '' ? '&search=' + payload.search.trim() : ''
        }`
      )
      const {typeExams, totalPages, total} = res.data
      return {
        typeExams,
        totalPages,
        total,
        success: true,
      }
    } catch (error) {
      const err: any = error as AxiosError
      const message = err.response?.data.fr
      return rejectWithValue({
        success: false,
        error: message || 'message',
      })
    }
  }
)

export const fetchAllTypeExams = createAsyncThunk(
  'typeExam/fetchAll',
  async (payload: FetchAllTypeExamsRequest, {rejectWithValue}) => {
    try {
      const res = await axios.get(
        `${fetchAllTypeExamsUrl}`
      )
      const {typeExams} = res.data
      return {
        typeExams,
        success: true,
      }
    } catch (error) {
      const err: any = error as AxiosError
      const message = err.response?.data.fr
      return rejectWithValue({
        success: false,
        error: message || 'message',
      })
    }
  }
)

export const fetchTypeExamById = createAsyncThunk(
  'typeExam/fetchById',
  async (payload: FetchTypeExamByIdRequest, {rejectWithValue}) => {
    try {
      const res = await axios.get(`${fetchTypeExamByIdUrl}/${payload.id}`)
      const {typeExam} = res.data
      return {
        typeExam,
        success: true,
      }
    } catch (error) {
      const err: any = error as AxiosError
      const message = err.response?.data.fr
      return rejectWithValue({
        success: false,
        error: message || 'message',
      })
    }
  }
)

export const createTypeExam = createAsyncThunk(
  'typeExam/create',
  async (payload: CreateTypeExamRequest, {rejectWithValue}) => {
    try {
      const res = await axios.post(createTypeExamUrl, payload)
      const {typeExam} = res.data
      return {
        typeExam,
        success: true,
      }
    } catch (error) {
      const err: any = error as AxiosError
      const message = err.response?.data.fr
      return rejectWithValue({
        success: false,
        error: message || 'message',
      })
    }
  }
)

export const updateTypeExam = createAsyncThunk(
  'typeExam/update',
  async (payload: UpdateTypeExamRequest, {rejectWithValue}) => {
    try {
      const res = await axios.post(updateTypeExamUrl, payload)
      const {typeExam} = res.data
      return {
        typeExam,
        success: true,
      }
    } catch (error) {
      const err: any = error as AxiosError
      const message = err.response?.data.fr
      return rejectWithValue({
        success: false,
        error: message || 'message',
      })
    }
  }
)

export const deleteTypeExam = createAsyncThunk(
  'typeExam/delete',
  async (payload: DeleteTypeExamRequest, {rejectWithValue}) => {
    try {
      const res = await axios.post(deleteTypeExamUrl, payload)
      const {typeExam} = res.data
      return {
        typeExam,
        success: true,
      }
    } catch (error) {
      const err: any = error as AxiosError
      const message = err.response?.data.fr
      return rejectWithValue({
        success: false,
        error: message || 'message',
      })
    }
  }
)

export const suspendTypeExam = createAsyncThunk(
  'typeExam/suspend',
  async (payload: SuspendTypeExamRequest, {rejectWithValue}) => {
    try {
      const res = await axios.post(suspendTypeExamUrl, payload)
      const {typeExam} = res.data
      return {
        typeExam,
        success: true,
      }
    } catch (error) {
      const err: any = error as AxiosError
      const message = err.response?.data.fr
      return rejectWithValue({
        success: false,
        error: message || 'message',
      })
    }
  }
)

export const activateTypeExam = createAsyncThunk(
  'typeExam/activate',
  async (payload: ActivateTypeExamRequest, {rejectWithValue}) => {
    try {
      const res = await axios.post(activateTypeExamUrl, payload)
      const {typeExam} = res.data
      return {
        typeExam,
        success: true,
      }
    } catch (error) {
      const err: any = error as AxiosError
      const message = err.response?.data.fr
      return rejectWithValue({
        success: false,
        error: message || 'message',
      })
    }
  }
)
